import EditUserPage from "./EditUserPage";

export default EditUserPage;
